import acquisitionTypes, {
  type AcquisitionType,
} from '../support/acquisitionTypes';
import queryKeys from '../support/uiStateKeys';

const dataKeys = [
  queryKeys.REMOVE_QUERY_ON_MODAL_CLOSE,
  queryKeys.SELECTED_INDEX,
];

// Each tab keeps its own selection: two tabs can share an option type but
// offer different sizes. The cart confirmations are the purchase tab after
// Add to cart, not tabs of their own, so they keep the size the user added.
const selectionTabs: Partial<Record<AcquisitionType, AcquisitionType>> = {
  [acquisitionTypes.MODIFIED_CART_CONFIRMATION]:
    acquisitionTypes.MODIFIED_LICENSE,
  [acquisitionTypes.CART_ADP_CONFIRMATION]: acquisitionTypes.LICENSE,
};

export const selectedIndexQueryKey = (
  optionType: string | undefined,
  acquisitionType: AcquisitionType | undefined
) => [
  ...dataKeys,
  optionType,
  (acquisitionType && selectionTabs[acquisitionType]) ?? acquisitionType,
];
